module.exports = __webpack_public_path__ + "static/media/elev-03.f6f68f27.svg";